export default class toggleHelper {
  setExpandedFalse(items) {
    items.map((item) => {
      if (item.getAttribute("aria-expanded")) {
        return item.setAttribute("aria-expanded", "false");
      }

      if (item.classList.contains("is-expanded")) {
        return item.classList.remove("is-expanded");
      }
    });
  }

  setExpandedTrue(items) {
    items.map((item) => {
      if (item.getAttribute("aria-expanded")) {
        return item.setAttribute("aria-expanded", "true");
      }

      if (!item.classList.contains("is-expanded")) {
        return item.classList.add("is-expanded");
      }
    });
  }

  toggleAttr(item, toggleItems) {
    return item.getAttribute("aria-expanded") == "false"
      ? this.setExpandedTrue(toggleItems)
      : this.setExpandedFalse(toggleItems);
  }

  toggleClass(item) {
    return item.classList.contains("is-expanded")
      ? this.setExpandedFalse([item])
      : this.setExpandedTrue([item]);
  }

  hasSameParent(a, b) {
    return a.getAttribute("data-parent") == b.getAttribute("data-parent");
  }

  hideContainer(container) {
    container.map((item) => {
      return this.setExpandedFalse([item]);
    });
  }

  isExpanded(item) {
    return item.getAttribute("aria-expanded") == "true";
  }
}
